import { render, staticRenderFns } from "./TiendasComponent.vue?vue&type=template&id=d3372e48&"
import script from "./TiendasComponent.vue?vue&type=script&lang=js&"
export * from "./TiendasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports